import { useEffect, useState } from 'react'
import type { CallData } from 'app/generated/graphql'
import { gqlFetchOne } from 'app/lib/graphqlClient'
import { bg } from 'lib/background'
import type { OpsCall } from './voiceAgentOps.types'

/**
 * The AI Call Details drawer shared by the Ops call lists: which call is open and its
 * full `CallData` (every exposed field, `data` being the ElevenLabs post-call payload).
 * `CallData.id` is the call id, which is the activity's `typeId`.
 */
export function useOpsCallDetail() {
  const [selectedCall, setSelectedCall] = useState<OpsCall>()
  // undefined while loading; null when the call has no CallData (webhook never arrived, or a preview row).
  const [callData, setCallData] = useState<CallData | null>()

  useEffect(() => {
    let active = true
    setCallData(undefined)
    const callId = selectedCall?.typeId
    if (selectedCall && !callId) setCallData(null)
    if (callId) {
      bg(async () => {
        const result = await gqlFetchOne<CallData>(`callDatum`, callId)
        if (active) setCallData(result ?? null)
      })
    }
    return () => {
      active = false
    }
  }, [selectedCall?.id])

  return {
    selectedCall,
    callData,
    isCallDataLoading: !!selectedCall && callData === undefined,
    openCall: (call: OpsCall) => setSelectedCall(call),
    closeCall: () => setSelectedCall(undefined),
  }
}
